<template>
  <el-row class="card-device-alert">
    <el-row class="header-row" type="flex">
      <el-row type="flex" class="col__title col__title--main" align="center">
        <p class="count-title">{{ name }} :</p>
        <p class="count-content">{{ `${totalDevicesWithAlerts}/${totalDevices}` }}</p>
      </el-row>
    </el-row>

    <el-row
      v-if="Object.keys(alertTypes).length > 0"
      :key="Object.keys(alertTypes).length + 'PM'"
      class="progress-item-container"
    >
      <el-col
        v-for="data in getProgressData"
        :key="data.alertType"
        :percentage="data.percentage"
        :color="data.color"
        class="progress-item"
      >
        <el-col :span="2">
          <img :src="renderAlertIcon(data.alertType)" />
        </el-col>
        <el-col :span="22">
          <el-row class="progress-item__content">
            <p class="title">{{ renderAlertName(data.alertType) }}</p>
            <p class="value">{{ data.alertCount }}</p>
          </el-row>
          <el-progress style :percentage="data.percentage" :color="data.color" :show-text="false"></el-progress>
        </el-col>
      </el-col>
    </el-row>
    <div v-else class="middle-no-data">
      <el-tag>{{$t("No_alerts")}}</el-tag>
    </div>
  </el-row>
</template>

<script>
import errorAlertsUtils from "@/utils/errorAlertsUtils";
import FILTER_ICON from "@/assets/filter.svg";

export default {
  name: "DeviceAlert",
  props: {
    name: String,
    count: Number,
    alertTypes: Object,
    totalDevicesWithAlerts: {
      default: 0
    },
    totalDevices: {
      default: 0
    }
  },
  components: {
    FILTER_ICON
  },
  data: function() {
    return {
      //   percentage: 20,
      customColor: "red",
      selectedAlertTypes: [],
      checkAll: false,
      isIndeterminate: false,
      FILTER_LOCAL_STORE_NAME: {
        PondMother: "ALERT_TYPE_FILTERING_PONDMOTHER",
        PondGuard: "ALERT_TYPE_FILTERING_PONDGUARD",
        ShrimpGuard: "ALERT_TYPE_FILTERING_SHRIMPGUARD"
      }
    };
  },
  mounted() {
    this.selectedAlertTypes = JSON.parse(
      localStorage.getItem(this.FILTER_LOCAL_STORE_NAME[this.name]) || "[]"
    );
  },
  computed: {
    getProgressData() {
      const list = [];
      for (const property in this.alertTypes) {
        const alertCount = this.alertTypes[property].count;

        let percentage = 0;
        if (this.count > 0 && alertCount) {
          percentage = Math.round((alertCount * 100) / this.count);
        }

        list.push({
          percentage,
          color: "red",
          alertType: property,
          alertCount
        });
      }
      return list;
    },
    filteredProgressData() {
      if (this.selectedAlertTypes.length > 0) {
        return this.getProgressData.filter(({ alertType }) =>
          this.selectedAlertTypes.includes(alertType)
        );
      } else {
        return this.getProgressData;
      }
    }
  },
  methods: {
    renderAlertIcon(alertCode) {
      return errorAlertsUtils.renderDeviceAlertIcon(alertCode);
    },
    renderAlertName(data) {
      return this.$t(errorAlertsUtils.renderAlertName(data));
    },
    handleCheckAllChange(val) {
      this.selectedAlertTypes = val
        ? this.getProgressData.map(({ alertType }) => alertType)
        : [];
      this.isIndeterminate = false;
    },
    handleChangeInSelectedColumns(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.columns.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.columns.length;
    },
    handleSaveDefault() {
      if (this.name === "PondMother") {
        localStorage.setItem(
          "ALERT_TYPE_FILTERING_PONDMOTHER",
          JSON.stringify(this.selectedAlertTypes)
        );
      } else if (this.name === "PondGuard") {
        localStorage.setItem(
          "ALERT_TYPE_FILTERING_PONDGUARD",
          JSON.stringify(this.selectedAlertTypes)
        );
      } else {
        localStorage.setItem(
          "ALERT_TYPE_FILTERING_SHRIMPTALK",
          JSON.stringify(this.selectedAlertTypes)
        );
      }
      this.visible = false;
      this.$notify({
        title: this.$t("Usrs_success_msg"),
        message: "Saved Selection as Defaults",
        duration: 5000,
        type: "success"
      });
    }
  }
};
</script>

<style lang="scss">
.alerts-bar-charts {
  .divider {
    width: 100%;
    height: 1px;
    opacity: 0.2;
    margin: 0 auto;
    display: inline-block;
    background-color: #6c7b8a;
    margin-bottom: 15px;
  }
  .card-device-alert {
    // margin-bottom: 25px;
    &:first-child {
      margin-top: 12px;
    }
    .align-left {
      margin-left: auto;
    }
    .progress-item {
      display: flex;
      align-items: center;
      padding: 10px 0px;
      &:first-child {
        padding-top: 0px;
      }
      img {
        height: 28px;
        width: 21px;
      }
      &__content {
        display: flex;
        align-items: baseline;
        margin-bottom: 5px;
        .title {
          opacity: 0.6;
          font-weight: $font_weight_header;
          @include responsiveProperty(
            font-size,
            $app_font_size_small,
            $app_font_size_1,
            $app_font_size_2
          );
        }
        .value {
          margin-left: auto;
          @include responsiveProperty(
            font-size,
            $app_font_size_small,
            $app_font_size_1,
            $app_font_size_2
          );
          font-weight: 600;
        }
      }
      .el-col:first-of-type {
        text-align: center;
      }
      .el-progress-bar__inner {
        opacity: 0.6;
      }
    }
    .header-row {
      align-items: center;
      display: flex;
      margin-bottom: 15px;
      justify-content: space-between;
      .col__title {
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
        color: #0a2463;
        font-weight: 600;
        align-items: center;
        &--main {
          @include responsiveProperty(
            font-size,
            $app_font_size_1,
            $app_font_size_2,
            $app_font_size_3
          );
          opacity: 0.9;
        }
      }
      .count-content {
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
        color: #0a2463;
        margin-left: 12px;
        letter-spacing: 1px;
        font-weight: 600;
      }
    }
    .middle-no-data {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
